export enum CommonErrorType {
  InvalidData = 'Invalid response data.',
  PermissionDenied = 'You dont`t have permissions to view this resource',
}
